/** Identity this package reports to the SDK routes. A test pins it to `package.json`. */
export const SDK_NAME = 'headless' as const;
export const SDK_VERSION = '1.23.0' as const;
